var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("החלפת טקסט לשאלות"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body", staticStyle: { height: "500px" } },
        [
          _c(
            "div",
            { staticClass: "DialogReportPaid__Component__Loading" },
            [
              _c(
                "b-field",
                { attrs: { label: "טקסט לחיפוש" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "טקסט להחלפה" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.replaceText,
                      callback: function ($$v) {
                        _vm.replaceText = $$v
                      },
                      expression: "replaceText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              disabled: !_vm.isValid,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }